import React from "react";
import { useParams } from "react-router-dom";
import useLiteratureCurrentView from "../hooks/useLiteratureCurrentView";
import { useVesselInfo } from "../../../fetch/fetchVesselInfo";
import { Typography } from "@mui/material";
import { usePhoneMode } from "../../../hooks";

export default function NavEngineInfo() {
    const { serialNumber } = useParams();
    const { phoneMode } = usePhoneMode();
    const { isInEngineInfo } = useLiteratureCurrentView();
    const { data, isLoading } = useVesselInfo(serialNumber);
    const { basicInfo } = data || {};

    if (!isInEngineInfo || isLoading) {
        return null;
    }

    return (
        <div style={{ textAlign: 'center' }}>
            {!phoneMode ? <Typography variant="h5">{basicInfo?.brand} {basicInfo?.modelDescription}</Typography> : null}
            <Typography variant="subtitle1">Serial: {basicInfo?.serialNumber} Model: {basicInfo?.modelNum}</Typography>
        </div>
    );
}